import {
  CheckCircle2, XCircle, AlertTriangle, Clock, Loader2, CircleDashed,
  FileCheck2, PauseCircle, HelpCircle, Sparkles, CheckCheck, X,
} from "lucide-react";

const MAP = {
  // --- crawler ---
  idle: { label: "Bereit", cls: "bg-gray-100 text-gray-600 border-gray-300", Icon: CircleDashed },
  running: { label: "Läuft", cls: "bg-sky-50 text-sky-800 border-sky-400", Icon: Loader2, spin: true },
  queued: { label: "Warteschlange", cls: "bg-amber-50 text-amber-800 border-amber-400", Icon: Loader2, spin: true },
  success: { label: "Neu + OCR", cls: "bg-green-50 text-green-800 border-green-500", Icon: CheckCheck },
  found_no_ocr: { label: "Gefunden, kein OCR", cls: "bg-amber-50 text-amber-800 border-amber-400", Icon: CheckCircle2 },
  empty: { label: "Nichts Neues", cls: "bg-amber-50 text-amber-800 border-amber-400", Icon: AlertTriangle },
  no_adapter: { label: "Kein Provider", cls: "bg-gray-100 text-gray-500 border-gray-300", Icon: X },
  skipped: { label: "Kein Provider", cls: "bg-gray-100 text-gray-500 border-gray-300", Icon: X },

  // --- document pipeline ---
  pending: { label: "Ausstehend", cls: "bg-gray-100 text-gray-600 border-gray-300", Icon: Clock },
  processing: { label: "In Analyse", cls: "bg-sky-50 text-sky-800 border-sky-400", Icon: Loader2, spin: true },
  error: { label: "Fehler", cls: "bg-red-50 text-red-800 border-red-500", Icon: XCircle },

  // --- document workflow ---
  neu: { label: "Neu", cls: "bg-sky-50 text-sky-800 border-sky-400", Icon: Sparkles },
  ocr_done: { label: "Neu", cls: "bg-sky-50 text-sky-800 border-sky-400", Icon: Sparkles },
  fertig: { label: "Fertig", cls: "bg-green-50 text-green-800 border-green-500", Icon: FileCheck2 },
  reviewed: { label: "Fertig", cls: "bg-green-50 text-green-800 border-green-500", Icon: FileCheck2 },
  zurueckgestellt: { label: "Zurückgestellt", cls: "bg-amber-50 text-amber-800 border-amber-400", Icon: PauseCircle },

  // --- QK (OK) status ---
  ok: { label: "OK", cls: "bg-green-50 text-green-800 border-green-500", Icon: CheckCircle2 },
  not_ok: { label: "Not OK", cls: "bg-red-50 text-red-800 border-red-500", Icon: XCircle },
  unklar: { label: "Unklar", cls: "bg-amber-50 text-amber-800 border-amber-400", Icon: HelpCircle },
  offen: { label: "Offen", cls: "bg-gray-100 text-gray-600 border-gray-300", Icon: CircleDashed },
};

export default function StatusBadge({ status, testId }) {
  const cfg = MAP[status] || MAP.idle;
  const { Icon } = cfg;
  return (
    <span
      data-testid={testId}
      className={`inline-flex items-center gap-1.5 whitespace-nowrap rounded px-2 py-0.5 text-xs font-semibold border ${cfg.cls}`}
    >
      <Icon className={`h-3.5 w-3.5 ${cfg.spin ? "animate-spin" : ""}`} />
      {cfg.label}
    </span>
  );
}
